import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import '@awesome.me/webawesome/dist/components/spinner/spinner.js';

@customElement('ns-loading')
export class NSLoading extends LitElement {
  @property({ type: String })
  label?: string;

  @property({ type: Boolean, reflect: true })
  inline = false;

  static styles = css`
    :host {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    :host([hidden]) {
      display: none;
    }

    .status {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--wa-space-xs);
    }

    :host([inline]) .status {
      flex-direction: row;
    }

    wa-spinner {
      --track-width: 4px;

      font-size: var(--ns-loading-size, var(--wa-font-size-4xl));
    }
  `;

  render() {
    return html`
      <div class="status" role="status">
        <wa-spinner aria-hidden="true"></wa-spinner>
        ${this.label
          ? html`
              <span>${this.label}</span>
            `
          : nothing}
      </div>
    `;
  }
}
